import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const token = auth.token();
  const isAnonymousAuth = req.url.includes('/Auth/login') || req.url.includes('/Auth/signup');

  const authReq =
    token && !isAnonymousAuth
      ? req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
          },
        })
      : req;

  return next(authReq).pipe(
    catchError((err: { status?: number }) => {
      if (err?.status === 401 && token && !isAnonymousAuth) {
        auth.logout();
      }

      return throwError(() => err);
    }),
  );
};
